import { combineReducers } from 'redux';

import { CHART_TYPES } from '../../constants';
import analyticsReducer from '../analyticsReducer';

export default combineReducers({
    [CHART_TYPES.HIGHEST_FILLED]: analyticsReducer({
        analyticsActionName: 'ANALYTICS_PERFORMANCE_HIGHEST_FILLED_APMS',
    }),
    [CHART_TYPES.LOW_PERFORMERS]: analyticsReducer({
        analyticsActionName: 'ANALYTICS_PERFORMANCE_LOW_PERFORMERS',
    }),
    [CHART_TYPES.LOWEST_FILLED]: analyticsReducer({
        analyticsActionName: 'ANALYTICS_PERFORMANCE_LOWEST_FILLED_APMS',
    }),
    [CHART_TYPES.TOP_PARCELS]: analyticsReducer({
        analyticsActionName: 'ANALYTICS_PERFORMANCE_TOP_PARCELS_PER_SLOT',
    }),
    [CHART_TYPES.TOP_PERFORMERS]: analyticsReducer({
        analyticsActionName: 'ANALYTICS_PERFORMANCE_TOP_PERFORMERS',
    }),
});
